import { toast, ToastOptions } from "react-toastify"

const baseOptions: ToastOptions = {
  position: "top-center",
}

export const notifyError = (message: string, error?: unknown): void => {
  const detail = error instanceof Error ? `: ${error.message}` : ""
  toast.error(`${message}${detail}`, baseOptions)
}

export const notifySuccess = (
  message: string,
  options?: ToastOptions,
): void => {
  toast.success(message, { ...baseOptions, ...options })
}

export const notifyInfo = (message: string, options?: ToastOptions): void => {
  toast.info(message, { ...baseOptions, ...options })
}
